import { useState } from "react"
import ActionMenu, {
  type ActionMenuItemProps,
} from "@/v2-backoffice-client/components/actionMenu"
import UserResetPasswordDialog from "@/v2-backoffice-client/user/resetPassword/UserResetPasswordDialog"

export type UserResetPasswordMenuItemProps = Omit<
  ActionMenuItemProps,
  "onClick"
> & {
  userId: number
}

function UserResetPasswordMenuItem(props: UserResetPasswordMenuItemProps) {
  const { userId, ...menuItemProps } = props
  const [isOpen, setIsOpen] = useState(false)

  return (
    <>
      <ActionMenu.Item
        iconSrc="key"
        onSelect={(e) => {
          e.preventDefault()
          setIsOpen(true)
        }}
        {...menuItemProps}
      >
        Reset Password
      </ActionMenu.Item>

      <UserResetPasswordDialog
        userId={userId}
        open={isOpen}
        onOpenChange={setIsOpen}
      />
    </>
  )
}

export default UserResetPasswordMenuItem
